import { getToken } from "./LocalStorageService";

import PraisoServices from "./PraisoServices";
import { APIURL } from "../config/app-globals.enum";

export const GetReportsListAPI = async (params) => {
    const token = getToken();
    let ApiUrl = `reports`;
    if (params.impersonationid) {
        ApiUrl = `${ApiUrl}?impersonationId=${params.impersonationid}`;
    }
    try {
        const response = await PraisoServices(
            ApiUrl,
            "get",
            {},
            {},
            {
                Authorization: `Bearer ${token}`
            }
        );
        try {
            return response;
        } catch (error) {
            const err = error as Error;
            return {
              status: {
                code: 1,
                message: err?.message,
              },
              content: null,
            };
          }
        } catch (error_1) {
          const err = error_1 as Error;
          return {
            status: {
              code: 1,
              message: err.message,
            },
            content: null,
          };
        }
};

export const GetDownloadReportAPI = async (reportId, params) => {
    let ApiUrl = `${APIURL.REPORT_API}${reportId}`;

    if (params.impersonationid) {
        ApiUrl = `${ApiUrl}?impersonationId=${params.impersonationid}`;
    }
    const token = getToken();
    try {
        const response = await PraisoServices(
            ApiUrl,
            "get",
            {},
            {},
            {
                Authorization: `Bearer ${token}`
            }
        );
        try {
            return response;
        } catch (error) {
            const err = error as Error;
            return {
              status: {
                code: 1,
                message: err?.message,
              },
              content: null,
            };
          }
        } catch (error_1) {
          const err = error_1 as Error;
          return {
            status: {
              code: 1,
              message: err.message,
            },
            content: null,
          };
        }
};

export const getReportsList = async (params) => {
    const data = await GetReportsListAPI(params);
    return data;
    // if (data.status.code !== 0 && data.status.code !== 200 && data.status.code !== 201) {
    //     return data;
    // } else {
    //     return data;
    // }
};

export const getDownloadReport = async (reportId, params) => {
    const data = await GetDownloadReportAPI(reportId, params);
    return data;
    // if (data.status.code !== 0 && data.status.code !== 200 && data.status.code !== 201) {
    //     return data;
    // } else {
    //     return data;
    // }
};
